import { render, staticRenderFns } from "./ContratoItem.vue?vue&type=template&id=44ac31bb&scoped=true"
import script from "./ContratoItem.vue?vue&type=script&lang=js"
export * from "./ContratoItem.vue?vue&type=script&lang=js"
import style0 from "./ContratoItem.vue?vue&type=style&index=0&id=44ac31bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac31bb",
  null
  
)

export default component.exports